import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NPDAY_75: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NPDAY_75,
  },
  {
    pageId: PageId.CHAT_UPSELL_NPDAY_75,
  },
  {
    pageId: PageId.UPSELL_NPDAY_75,
  },
  {
    pageId: PageId.DOWNLOAD_NPDAY_75,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
